import templateUrl from "./app-outdated.component.html";
import "./error-page.less";

/**
 * A component that shows a message to users about the app being out of date.
 */
export const AppOutdatedComponent = {
    templateUrl
};
